/*
    prints a stylized message to the console that links to our job listings
*/

const imageToBase64 = async (image: HTMLImageElement): Promise<string | null> => {
	return new Promise((resolve) => {
		fetch(image.src)
			.then((response) => response.blob())
			.then((blob) => {
				const reader = new FileReader();
				reader.onloadend = () => {
					if (typeof reader.result === "string") {
						resolve(reader.result);
					} else {
						resolve(null);
					}
				};
				reader.readAsDataURL(blob);
			})
			.catch(() => {
				resolve(null);
			});
	});
};

export const hiringMessage = async () => {
	if (typeof window === "undefined") {
		return;
	}

	if (!Object.prototype.hasOwnProperty.call(global, "navigator")) {
		return;
	}

	const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	const image = new Image();
	image.src = "/hiring-message-logo.png";

	image.onload = async () => {
		const dataBlob = await imageToBase64(image);

		const header = `
            ${isSafari ? `` : `display:block;`}
            font-family:sans-serif;
            font-size: 24px;
            ${isSafari ? `font-weight:600;` : `font-weight:500;`}
            ${isSafari ? `color: rgb(79, 70, 229);` : ``}
            border-radius:5px;
            ${isSafari ? `padding: 0px;` : `padding:35px 60px 30px 60px;`}
            ${isSafari ? `line-height: 32px` : `line-height: 0px;`};
            ${isSafari ? `` : `background: url("${dataBlob}") no-repeat center left`};
        `;

		const links = `
            ${isSafari ? `font-size:16px;` : `font-size: 18px`};
            ${isSafari ? `line-height:16px;` : `line-height: 18px`};
            font-family:sans-serif;
            font-weight:500;
            ${isSafari ? `padding: 0px;` : ` padding:0 0 0 60px;`};
        `;

		console.group("Join our team!");
		console.log(`%cWe're Hiring!`, header);
		console.log(`%cjobs@moment.dev`, links);
		console.groupEnd();
	};
};
